<div class="page-container">
  <div class="page-title">
    <span translate="SETTINGS_OVERRIDE.TITLE"> </span>
    <div class="size-fix">
      <pop-user-card></pop-user-card>
    </div>
  </div>

  <div class="box-layout">
    <h2 translate="SETTINGS_OVERRIDE.FEATURE_FLAGS"></h2>

    <div class="feature-switch"
         *ngFor="let flag of flags">
      <div class="label"
           translate="SETTINGS_OVERRIDE.FLAG.{{flag.key.toUpperCase()}}"></div>
      <div>
        <pop-switch [(isSwitched)]="flag.value"
                    (isSwichedChange)="setFlag(flag)"></pop-switch>
        <span [translate]="'SETTINGS_OVERRIDE.'+flag.value"></span>
      </div>
      <div class="overriden"
           *ngIf="flag.value !== flag.defaultValue">
        <span translate="SETTINGS_OVERRIDE.DEFAULT"></span>
        <span [translate]="'SETTINGS_OVERRIDE.'+flag.defaultValue"></span>
      </div>
    </div>
  </div>
